import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatInput} from '@angular/material/input';
import {FormControl, ReactiveFormsModule, Validators} from '@angular/forms';
import {Subject, take, takeUntil} from 'rxjs';
import {InfoMessageService} from "../../services/infomessage/infomessage.service";
import {AuthenticationService} from "../../services/authentication/authentication.service";

@Component({
  selector: 'app-resend-register-link-modal',
    imports: [
        MatInput,
        ReactiveFormsModule
    ],
  templateUrl: './resend-register-link-modal.component.html',
  styleUrl: './resend-register-link-modal.component.sass'
})
export class ResendRegisterLinkModalComponent {
    private $destroy: Subject<void> = new Subject<void>()
    mailFormControl = new FormControl('', [Validators.required])

    constructor(
        public dialogRef: MatDialogRef<ResendRegisterLinkModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private authService: AuthenticationService,
        private infoMessage: InfoMessageService
    ) {
    }

    onClose(): void {
        this.$destroy.next();
        this.$destroy.complete();
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close(true);
    }

    resendLink(): void {
        const query = {
            email: this.mailFormControl.value
        }
        this.authService.resendSuccessLink(query)
            .pipe(takeUntil(this.$destroy))
            .subscribe({
                next: () => {
                    this.onSubmit();
                },
                error: () => {
                    this.infoMessage.createMessage('Falls Sie Ihre E-Mail-Adresse noch nicht bestätigt haben, erhalten Sie jetzt eine neue E-Mail mit Bestätigungslink.')
                    this.onClose();
                }
            })
    }

}
